import React, { useContext, useEffect, useState } from 'react';
import noop from 'lodash/noop';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import ToolTip from 'zignal-landscape/lib/ToolTip';
import ChevronRightIcon from 'zignal-landscape/lib/Icon/ChevronRightIcon';
import Styles from '../AuthorGroups.css';
import { AuthorGroupsContext } from '../AuthorGroups';
import classnames from 'classnames';
import {
  removeAnyAuthorGroupIdFromURL,
  updateAuthorGroupURLWithId
} from '../AuthorGroupsUtils';

const DEFAULT_AUTHOR_GROUPS = [];

const AuthorGroupsList = ({
  isReadOnly,
  groupsLimit = 0,
  authorGroups = DEFAULT_AUTHOR_GROUPS,
  editAuthorGroupId
}) => {
  const [ selectedAuthorGroupIndex, setSelectedAuthorGroupIndex ] = useState();
  const { dispatch } = useContext(AuthorGroupsContext);

  useEffect(() => {
    if (!isEmpty(authorGroups) && editAuthorGroupId) {
      const index = authorGroups.findIndex(ag => ag.id === editAuthorGroupId);
      if (index !== -1) {
        handleItemClick(index, editAuthorGroupId);
      }
    }
    return () => setSelectedAuthorGroupIndex();
  }, [ authorGroups, editAuthorGroupId ]);

  const getAuthorGroupsListItemStyle = index =>
    ((index === selectedAuthorGroupIndex) ? Styles.authorGroupsListItemSelected : Styles.authorGroupsListItem);

  const getAuthorGroupsListItemArrowStyle = index =>
    ((index === selectedAuthorGroupIndex) ? Styles.authorGroupsListItemArrowSelected : Styles.authorGroupsListItemArrow);

  const handleItemClick = (index, id) => {
    setSelectedAuthorGroupIndex(index);
    dispatch({
      type: 'set-selected-author-group',
      authorGroup: authorGroups[index],
      title: 'EDIT GROUP'
    });
    updateAuthorGroupURLWithId(id);
  };

  const handleAddAuthorGroup = () => {
    setSelectedAuthorGroupIndex(-1);
    dispatch({type: 'new-author-group'});
    removeAnyAuthorGroupIdFromURL();
  };

  // using global classnames to match the other settings pages, i.e. Tags, Datasets, Smart Fitlers
  const addNewClassnames = classnames({
    'add-new-model': true,
    'add-new-model-disabled': isReadOnly || authorGroups.length >= groupsLimit,
  });

  const onAddNewClick = isReadOnly || authorGroups.length >= groupsLimit ? noop : handleAddAuthorGroup;

  return (
    <div className={Styles.authorGroupsListPanel} data-cy="author-groups-list">
      <div className={Styles.authorGroupsHeader}>
        <div>
          <div className={Styles.authorGroupsListTitle}>{'Groups'}</div>
          <div className={Styles.authorGroupsUsageCount}>
            {`Using ${authorGroups.length} of ${groupsLimit}`}
          </div>
        </div>
        <ToolTip tooltipText="Add Group">
          <div className={addNewClassnames} onClick={onAddNewClick}>+</div>
        </ToolTip>
      </div>
      <ul className={Styles.authorGroupsList}>
        {
          authorGroups.map((ag, index) => (
            <li
              key={ag.id}
              className={getAuthorGroupsListItemStyle(index)}
              onClick={() => handleItemClick(index, ag.id)}
            >
              {ag.name}
              <ChevronRightIcon className={getAuthorGroupsListItemArrowStyle(index)} />
            </li>
          ))
        }
      </ul>
    </div>
  );
};

AuthorGroupsList.propTypes = {
  isReadOnly: PropTypes.bool,
  groupsLimit: PropTypes.number,
  authorGroups: PropTypes.array,
  editAuthorGroupId: PropTypes.string
};

export default AuthorGroupsList;
